<template>
    <div class="w-full" ref="keepInView">
        <Dropdown :block="true" ref="dropdown" :tabindex="-1" v-if="!manual">
            <template #button="{ open }">
                <Input
                    :placeholder="placeholder"
                    class="text-left w-full"
                    groupClass="bg-grey text-15 w-full"
                    inputClass="w-full"
                    :label="label !== null ? label : null"
                    errorName="loquate_address_id"
                    :hideError="true"
                    :disabled="disabled"
                    v-model:value="value"
                    name="loquate_address"
                    @keyup="search"
                    :tabindex="tabindex"
                >
                    <template #right>
                        <div class="w-10 pl-4 mr-2" v-if="searching">
                            <div class="dot-pulse flex shrink-0"></div>
                        </div>

                        <slot name="right" />

                        <button
                            @click="clear"
                            v-if="!(searching || address.loquate_address_id == null)"
                            class="pr-3 icon-hover"
                            :disabled="searching || address.loquate_address_id == null || disabled"
                        >
                            <IconClose class="w-4.5 h-4.5" />
                        </button>
                    </template>
                </Input>
            </template>

            <template #menu>
                <div
                    class="bg-grey text-14 border border-t-0 border-grey-500"
                    style="max-height: 210px; overflow-y: scroll"
                    v-if="items != null"
                >
                    <div v-if="!searching && items.length == 0"></div>

                    <div
                        class="py-3 px-4 cursor-pointer hover:bg-black hover:bg-opacity-5"
                        v-for="(item, i) in items"
                        @click="setAddress(item)"
                        :id="'address-' + i"
                    >
                        <template v-if="item.Type == 'Address'">
                            <p class="text-15 font-medium">
                                {{ item.Text }}
                            </p>
                            <span class="text-grey-900 text-13">{{ item.Description }}</span>
                        </template>

                        <template v-if="item.Type == 'Postcode'">
                            <p class="text-15 font-medium">
                                {{ item.Description.split(' - ')[0] }}
                            </p>
                            <span class="text-grey-900 text-13">{{ item.Description.split(' - ')[1] }} - {{ item.Text }}</span>
                        </template>

                        <template v-if="item.Type == 'Street'">
                            <p class="text-15 font-medium">
                                {{ item.Description.split(' - ')[0] }}
                            </p>
                            <span class="text-grey-900 text-13">{{ item.Description.split(' - ')[1] }} - {{ item.Text }}</span>
                        </template>
                    </div>

                    <div class="py-3 px-4 cursor-pointer hover:bg-black hover:bg-opacity-5" @click="manual = true">
                        <p class="text-15 font-medium">Can't find your address?</p>
                        <span class="text-grey-900 text-13">Enter address manually</span>
                    </div>
                </div>
            </template>
        </Dropdown>

        <Error :error="error()" />

        <input type="hidden" name="loquate_address_id" :value="manual ? 'manual' : address.loquate_address_id" />

        <div class="" v-show="manual">
            <Input
                :label="label"
                type="text"
                name="address_line_1"
                v-model:value="address.address_line_1"
                placeholder="Address line 1"
                :hideError="true"
            />
            <Input
                type="text"
                name="address_line_2"
                v-model:value="address.address_line_2"
                boxClass="!border-y-0"
                placeholder="Address line 2"
                :hideError="true"
                errorName="address_line_1"
            />
            <Input type="text" name="town" v-model:value="address.town" class="-mt-px" placeholder="City/town" :hideError="true" />
            <Input type="text" name="postcode" v-model:value="address.postcode" class="-mt-px" placeholder="Postcode" :hideError="true" />

            <Error :error="error('address_line_1')" />
            <Error :error="error('address_line_2')" />
            <Error :error="error('town')" />
            <Error :error="error('postcode')" />
        </div>
    </div>
</template>

<script>
import { ofetch } from 'ofetch'
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'

export default {
    props: {
        company: {
            type: Object,
            default: function () {
                return {}
            },
        },
        label: {
            type: [Boolean, String],
            default: 'Enter address or post code',
        },
        placeholder: {
            type: String,
            default: 'Enter address or post code',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            default: null,
        },
    },

    data() {
        return {
            value: '',
            lOptions: [],
            items: null,
            searching: false,
            address: {
                loquate_address_id: this.company.loquate_address_id,
                address_line_1: this.company.address_line_1,
                address_line_2: this.company.address_line_2,
                town: this.company.town,
                postcode: this.company.postcode,
            },
            manual: this.company.loquate_address_id == 'manual',
            ZapoLogoJson,
        }
    },

    mounted() {
        if (this.address.loquate_address_id != null) {
            this.value = this.address.address_line_1 + ', ' + this.address.town + ', ' + this.address.postcode
        }
    },

    methods: {
        clear() {
            this.value = ''
            this.address = {
                loquate_address_id: null,
                address_line_1: null,
                address_line_2: null,
                town: null,
                postcode: null,
            }
        },

        search(event = null) {
            let id = null
            try {
                event.preventDefault()
            } catch (error) {
                id = event
            }

            // console.log([event])
            this.searching = true

            this.$help.delay(async () => {
                if (this.value == null || this.value == '' || this.value.length < 2) {
                    this.searching = false
                    // console.log('hide menu???')
                    this.$refs.dropdown.hide()
                    return
                }

                let response = await ofetch(
                    'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws?Key=NP99-CW63-PH42-GB59&Countries=GB,IE&Limit=3&Language=&Text=' +
                        this.value +
                        (id != null ? '&Container=' + id : ''),
                    { parseResponse: JSON.parse },
                )

                // console.log(response.Items.length)

                this.items = response.Items
                this.$refs.dropdown.show()

                setTimeout(() => {
                    this.moveToTop()
                }, 350)
                this.searching = false
            }, 300)
        },

        async setAddress(address) {
            this.searching = true

            if (address.Type != 'Address') {
                this.search(address.Id)
            } else {
                let response = await ofetch(
                    'https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json3.ws?Key=NP99-CW63-PH42-GB59&Id=' + address.Id,
                    { parseResponse: JSON.parse },
                )
                let a = response.Items[0]

                this.address.loquate_address_id = address.Id
                this.address.address_line_1 = a.Line1
                this.address.address_line_2 = a.Line2
                this.address.town = a.City
                this.address.postcode = a.PostalCode

                this.$refs.dropdown.hide()
                this.searching = false
                this.items = null
                this.value = a.Line1 + ', ' + a.City + ', ' + a.PostalCode

                this.$emit('addressSet')
            }
        },

        moveToTop() {
            let bounding = document.activeElement.getBoundingClientRect()
            // console.log('this.$refs.keepInView.offsetTop', this.$refs.keepInView.offsetTop)
            // console.log('new top', document.activeElement.getBoundingClientRect().top - 32)

            window.scrollTo({
                top: this.$refs.keepInView.offsetTop + 60,
                // top: document.activeElement.getBoundingClientRect().top,
                behavior: 'smooth',
            })
        },

        error(key = 'loquate_address_id') {
            let inputForm = this.$help.getComponent(this, 'InputForm')

            return inputForm != null ? inputForm.$data.errors.has(key) : false
        },
    },
}
</script>
